import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import { ChangeEvent, forwardRef, useCallback } from 'react';

export type ICheckboxProps = Omit<MuiCheckboxProps, 'name' | 'onChange' | 'checked'> & {
    name: string;
    value?: boolean;
    enableDOMAttributeRequired?: boolean;
    onChange?: (event: ChangeEvent<HTMLInputElement>, isChecked: boolean) => void;
};

export const Checkbox = forwardRef<HTMLButtonElement, ICheckboxProps>(function InnerCheckBox(
    {
        color = 'success',
        enableDOMAttributeRequired = false,
        hidden,
        readOnly,
        required = false,
        value,
        onChange,
        ...rest
    },
    ref
) {
    const handleChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
            if (onChange && !readOnly) {
                onChange(event, checked);
            }
        },
        [readOnly, onChange]
    );

    return (
        <MuiCheckbox
            data-testid={`checkbox_${rest.name}`}
            {...rest}
            ref={ref}
            checked={value === true}
            color={color}
            hidden={hidden}
            readOnly={readOnly}
            required={enableDOMAttributeRequired && required}
            sx={hidden ? { ...rest.sx, display: 'none' } : rest.sx}
            onChange={handleChange}
        />
    );
});

export default Checkbox;
